module.exports = __webpack_public_path__ + "img/home.f91226eb.svg";